export const name = 're-multi-quantity-selector'

import {allValidationsRules as validationsRules, defaultFormFields} from './form'

import props from './props'
export {props, validationsRules, defaultFormFields}

import ComponentMixin from '../../../../../mixins/components/complex'
import BaseInputMixin from '../../../../../mixins/form/base-input'
import ResponsiveMixin from '../../../../../mixins/responsive'
import ProductsMixin from '../../../../../mixins/store/products'

export const mixins = [ComponentMixin, BaseInputMixin, ResponsiveMixin, ProductsMixin]

// data
const propDefs = props
export const data = {
  propDefs,
}

export default {
  name,
  mixins,
  props,
  data,

}
